import * as React from "react";
import { connect } from "react-redux";
import Paper from "@material-ui/core/Paper";
import DonationsTable from "./DonationsTable";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { pickBy } from "lodash";
import { CSVLink } from "react-csv";

export interface DonationEntity {
  firstname: string;
  lastname: string;
  amount: string;
  city: string;
  postalCode: string;
  country: string;
}
const styles = {
  flex: {
    display: "flex",
    justifyContent: "space-between",
    margin: "60px 0",
  },
  csv: {},
};
class DonationsListContainer extends React.Component<any> {
  generateCSVData = () => {
    const { donations } = this.props;
    const data = [];

    const formatDate = (date) => {
      const myDate = new Date(date);
      return `${myDate.getFullYear()}-${
        myDate.getMonth() + 1
      }-${myDate.getDate()} ${myDate.getHours()}:${myDate.getMinutes()}`;
    };

    for (let donationKey in donations) {
      const donation = donations[donationKey];
      data.push({
        DATE: donation.timestamp && formatDate(donation.timestamp),
        CHARITY: donation.charityName || "",
        CAMPAIGN: donation.campaignId || "",
        AMOUNT: donation.amount
          ? !donation.amount.includes("£")
            ? `£ ${donation.amount}`
            : donation.amount
          : 0,
        TYPE: donation.campaignType || "donation",
        "MONTHLY/ONE-OFF": donation.type,
        URL: donation.url,
        "PAYMENT PLATFORM":
          donation.campaignType === "petition"
            ? ""
            : donation.payment_type || "stripe",
        "FIRST NAME":
          donation.firstname ||
          (donation.personalDetails && donation.personalDetails.firstname) ||
          (donation.customer &&
            donation.customer.personalDetails &&
            donation.customer.personalDetails.firstname) ||
          "",
        "LAST NAME":
          donation.lastname ||
          (donation.personalDetails && donation.personalDetails.lastname) ||
          (donation.customer &&
            donation.customer.personalDetails &&
            donation.customer.personalDetails.lastname) ||
          "",
        "EMAIL ADDRESS":
          donation.email ||
          (donation.personalDetails && donation.personalDetails.email) ||
          (donation.customer &&
            donation.customer.personalDetails &&
            donation.customer.personalDetails.email) ||
          "",
        ...(donation.giftAidInfo && typeof donation.giftAidInfo !== "string"
          ? {
              ADDRESS: `${donation.giftAidInfo.addressLineOne}, ${donation.giftAidInfo.addressLineTwo}`,
              CITY: donation.giftAidInfo.city,
              "POST CODE": donation.giftAidInfo.postCode,
            }
          : {
              "POST CODE": donation.postCode || "",
            }),
        "GIFT AID":
          donation.giftAidInfo && typeof donation.giftAidInfo !== "string"
            ? "YES"
            : "NO",
        "OPTED IN":
          donation.hasOptedForEmailUpdates ||
          (donation.personalDetails &&
            donation.personalDetails.hasOptedForEmailUpdates) ||
          (donation.customer &&
            donation.customer.personalDetails &&
            donation.customer.personalDetails.hasOptedForEmailUpdates)
            ? "YES"
            : "NO",
      });
    }
    return data;
  };

  render() {
    const { donations, classes } = this.props;
    return (
      <div>
        <div className={classes.flex}>
          <Typography variant="display1">DONATIONS</Typography>
          <Button variant="contained" color="primary">
            <Typography variant="display2">
              <CSVLink
                data={this.generateCSVData()}
                style={{ color: "inherit" }}
                filename="Donations.csv"
                target="_self"
              >
                EXPORT CSV FORMAT
              </CSVLink>
            </Typography>
          </Button>
        </div>
        <Paper style={{ padding: 20, overflowX: "scroll" }}>
          <DonationsTable donations={donations} />
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = ({
  donations,
  auth: { charityKey, isAdmin },
  petitions,
}) => {
  const donationsData = donations.all;
  const petitionsData = petitions;
  if (!isAdmin && !charityKey) return { donations: {} };

  if (!isAdmin && charityKey) {
    const pickedDonations = pickBy(
      donationsData,
      (donation) =>
        donation.selectedCharityId === charityKey ||
        donation.charityId === charityKey
    );
    const pickedPetitions = pickBy(
      petitionsData,
      (petition) => petition.charityId === charityKey
    );
    return {
      donations: { ...pickedDonations, ...pickedPetitions },
    };
  }
  return {
    donations: { ...donationsData, ...petitionsData },
  };
};

export const DonationsList = connect(mapStateToProps)(
  withStyles(styles)(DonationsListContainer)
);
